export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <a className={`brand-mark${compact ? " brand-mark--compact" : ""}`} href="/" aria-label="AXON home">
      <span className="brand-mark__word">AXON</span>
      {!compact && <span className="brand-mark__sub">VIBES · RHYTHM · CONNECTION</span>}
    </a>
  );
}
